module.exports = __webpack_public_path__ + "static/media/Yellow_mushroom.90519f7d.png";